import {Ng1Controller, StateService, TargetState, Transition} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {QbCustomerShipToAddressDto} from "../../model/QbCustomerShipToAddressDto";
import {QbDataExtensionDefinitionDto} from "../../model/QbDataExtensionDefinitionDto";
import {DisposeBag} from "../../modules/DisposeBag";
import * as angular from "angular";
import {DebounceFactory} from "../../modules/DebounceModule";
import {IToasterService} from "ngtoaster";
import {IFormController} from "angular";
import {SpinnerService} from "../../modules/SpinnerModule";
import {QbCustomerEditDto} from "../../model/QbCustomerEditDto";
import {QbAdditionalContactDto} from "../../model/QbAdditionalContactDto";
import {QbNameResultDto} from "../../model/QbNameResultDto";
import {QbAddress} from "../../model/QbAddress";

export default class EditController implements Ng1Controller {
    private customer: QbCustomerEditDto;
    private dataExts: QbDataExtensionDefinitionDto[];
    private disposeBag = new DisposeBag();
    private form: IFormController;
    private dirtyReload: boolean;
    private saving: boolean;
    private contactNames = ['Main Phone', 'Work Phone', 'Home Phone', 'Mobile', 'Fax', 'Alt. Phone', 'Alt. Mobile', 'Alt. Fax',
        'Main Email', 'CC Email', 'Alt. Email 1', 'Alt. Email 2', 'Website', 'LinkedIn', 'Facebook', 'Twitter',
        'URL 1', 'URL 2', 'URL 3', 'URL 4', 'Skype ID', 'Other 1', 'Other 2', 'Other 3'];
    private contactNameDefaults = ['Main Phone', 'Work Phone', 'Mobile', 'Fax', 'Main Email', 'CC Email', 'Website', 'Other 1'];
    private nameValidationResult: QbNameResultDto;

    $onInit(): void {
        if (this.$state.is('customer.new')) {
            this.customer = new QbCustomerEditDto();
            this.customer.isLead = !!this.$stateParams.lead;
            this.customer.isActive = true;
            this.customer.billAddress = new QbAddress();
            this.customerPopulate();
        }
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        this.disposeBag.finalize();
        this.toaster.clear(null, 'customerEditDirty');
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
        console.debug('uiOnParamsChanged', newValues, $transition$);
        this.$stateParams = newValues;
        this.refresh();
    }

    constructor(private $dataHub: DataHubService,
                private $state: StateService,
                private $stateParams: any,
                private $debounce: DebounceFactory,
                private toaster: IToasterService,
                private $spinner: SpinnerService) {
        $dataHub.onCustomer(c => {
            if (this.customer && !angular.equals(this.customer, c) && this.form.$dirty && !this.saving) {
                this.dirtyReload = true;
                console.warn('dirty customer update');
                this.toaster.clear(null, 'customerEditDirty');
                // @ts-ignore
                this.toaster.warning({
                    toastId: 'customerEditDirty',
                    title: "Customer updated",
                    body: "This customer has been updated.. click here to reload the customer and discard your changes",
                    showCloseButton: true,
                    timeout: 0,
                    tapToDismiss: true,
                    clickHandler: (toast, isClose) => {
                        if (!isClose) this.reset();
                        return true;
                    }
                });
                return;
            }
            this.customer = <QbCustomerEditDto>c;
            this.customer["dataExtensionsDict"] = this.customer.dataExtensions.reduce((x, item) => {
                x[item.dataExtName] = item.dataExtValue;
                return x;
            }, {});
            this.customerPopulate();

        }, this.disposeBag);
        $dataHub.onConnected(this.refresh, this.disposeBag);
    }

    reset = () => {
        this.customer = null;
        this.dirtyReload = false;
        this.form.$setPristine();
        this.refresh();
    }
    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        this.refreshDebounce();
    };

    refreshDebounce = this.$debounce(() => {
        this.customerLoad(this.$stateParams.customerGuid);
        this.$dataHub.customerDataExtensionList().then(ret => this.dataExts = ret);
    }, 1000, true);


    customerLoad = (guid) => {
        console.debug('customerLoad', guid);

        if (!this.$dataHub.isConnected) return;
        if (!guid) return;
        this.$dataHub.customerGet(guid);
    };

    customerPopulate = () => {
        if (!this.customer.additionalContacts) this.customer.additionalContacts = [];
        while (this.customer.additionalContacts.length < 8) {
            let inUse = this.customer.additionalContacts.map(x => x.contactName);
            let next = this.contactNameDefaults.filter(name => inUse.some(x => x == name) == false)[0];
            let contact = new QbAdditionalContactDto();
            contact.rowId = this.customer.additionalContacts.length;
            contact.contactName = next;
            this.customer.additionalContacts.push(contact);
        }
    }

    getContactNames = (current: QbAdditionalContactDto) => {
        let inUse = this.customer.additionalContacts.filter(x => x != current).map(x => x.contactName);
        return this.contactNames.filter(name => inUse.some(x => x == name) == false);
    }

    private _shipTo: QbCustomerShipToAddressDto;

    get shipTo(): QbCustomerShipToAddressDto {
        if (this._shipTo) return this._shipTo;
        return this.customer?.shipToAddresses?.find(s => s.defaultShipTo);
    }

    set shipTo(value: QbCustomerShipToAddressDto) {
        this._shipTo = value;
    }

    shipToAdd() {
        let name = prompt("Name for new shipping address?");
        if (!name) return;
        if (this.customer.shipToAddresses.some(x => x.name == name)) {
            alert(name + ' is already in use');
            return;
        }
        var newShipTo = new QbCustomerShipToAddressDto();
        newShipTo.name = name;
        this.customer.shipToAddresses.push(newShipTo);
        this.shipTo = newShipTo;
    }

    shipToDelete() {
        if (this.shipTo) {
            this.customer.shipToAddresses.remove(this.shipTo, x => x);
            this.shipTo = null;
        }
    }

    shipToCopyBilling() {
        if (!this._shipTo) {
            this._shipTo = new QbCustomerShipToAddressDto();
            if (this.customer.shipToAddresses.length == 0) this._shipTo.defaultShipTo = true;
            this.customer.shipToAddresses.push(this._shipTo);
        }
        let count = 0;
        while (!this._shipTo.name) {
            count++;
            let name = "Ship To " + count;
            if (this.customer.shipToAddresses.some(x => x.name == name)) continue;
            this._shipTo.name = name;
            break;
        }

        this._shipTo.addr1 = this.customer.billAddress.addr1;
        this._shipTo.addr2 = this.customer.billAddress.addr2;
        this._shipTo.addr3 = this.customer.billAddress.addr3;
        this._shipTo.city = this.customer.billAddress.city;
        this._shipTo.state = this.customer.billAddress.state;
        this._shipTo.postalCode = this.customer.billAddress.postalCode;
        this._shipTo.country = this.customer.billAddress.country;
        this._shipTo.note = this.customer.billAddress.note;
    }

    save() {
        this.$spinner.show('Saving...');
        this.saving = true;
        this.$dataHub.customerSave(this.customer)
            .then(custGuid => this.$state.go('customer.view', {customerGuid: custGuid}))
            .catch(this.$dataHub.defaultErrorHandler)
            .finally(() => {
                this.saving = false;
                this.$spinner.hide();
            });
    }

    validateName() {
        this.$dataHub.customerNameValidate(this.customer)
            .then(ret => this.nameValidationResult = ret);
    }

    nameChange() {
        if (!this.customer.companyName) this.customer.companyName = this.customer.name;
        if (!this.customer.billAddress.addr1) this.customer.billAddress.addr1 = this.customer.name;
    }
}
